import { toggleCheckoutDevMode } from 'actions/CheckoutActions'
import SwitchButton from 'LuxKit/Switch/SwitchButton'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import config from 'constants/config'
import withMountGuard from 'hocs/withMountGuard'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import React, { useCallback } from 'react'

function CheckoutDevModeToggle() {
  const dispatch = useAppDispatch()
  const isDevToolsEnabled = useAppSelector(state => state.checkout.cart.isDevToolsEnabled)
  const handleChange = useCallback(() => {
    dispatch(toggleCheckoutDevMode())
  }, [dispatch])

  return <CSSBreakpoint min="largeDesktop">
    <SwitchButton checked={isDevToolsEnabled} onChange={handleChange}>
      {'<dev />'}
    </SwitchButton>
  </CSSBreakpoint>
}

export default withMountGuard(config.UNIVERSAL_CHECKOUT_DEV_STATE_ENABLED)(CheckoutDevModeToggle)
